<template>
  <div id="header-navigation-tabs" class="navigation-list">
    <div class="mds-site-navigation">
      <ul class="mds-site-navigation__list">
        <li
          v-for="item in items"
          :key="item.id"
          :class="{ 'mds-site-navigation__list-item--active': item.id === selected }"
          class="mds-site-navigation__list-item"
        >
          <div class="mds-site-navigation__list-item-inner">
            <a
              @click="selectItem(item.id)"
              class="mds-button mds-button--flat mds-site-navigation__button"
            >
              {{ item.text }}
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'navigation-list',
  props: {
    items: {
      type: Array,
      default() {
        return [
          {
            id: 'universe',
            text: 'Universe',
          },
        ];
      },
    },
    selected: {
      type: String,
      default: 'universe',
    },
  },
  methods: {
    selectItem(id) {
      this.$emit('selectedItem', id);
    },
  },
};
</script>
<style lang="scss">
.navigation-list {
  .mds-site-navigation {
    background: #12698d;

    &__button {
      color: $mds-color-white;
    }

    &__list {
      justify-content: flex-start;
    }

    &__list-item {
      margin: 0;
    }

    &__list-item--active {
      .mds-site-navigation__list-item-inner {
        box-shadow: inset 0 -6px 0 0 #061c25;
      }
    }
  }
}
</style>
